import React from 'react';
import { MoreVertical, Send, Paperclip } from 'lucide-react';
import Logo from './Logo';

const ChatMockup: React.FC = () => {
  return (
    <div className="relative w-full max-w-sm mx-auto animate-float">
      {/* Glow Effect behind */}
      <div className="absolute inset-0 bg-mira-accent/20 blur-3xl rounded-full -z-10 transform scale-90 translate-y-4"></div>

      {/* Phone Body */}
      <div className="bg-mira-surface border border-mira-border rounded-3xl overflow-hidden shadow-2xl relative">
        
        {/* Header */}
        <div className="bg-[#1A2333] p-4 flex items-center justify-between border-b border-mira-border">
          <div className="flex items-center space-x-3">
            <div className="w-8 h-8 rounded-full bg-gradient-to-tr from-mira-accent to-blue-400 flex items-center justify-center">
              <Logo className="w-4 h-4 text-white" />
            </div>
            <div>
              <p className="text-sm font-semibold text-white">Dental Elite Bot</p>
              <p className="text-xs text-mira-accent flex items-center gap-1">
                <span className="w-1.5 h-1.5 rounded-full bg-green-500 animate-pulse"></span>
                En línea 24/7
              </p>
            </div>
          </div>
          <MoreVertical className="w-5 h-5 text-gray-400 cursor-pointer" />
        </div>

        {/* Chat Area */}
        <div className="p-4 space-y-3 h-[380px] bg-[#0F1623] overflow-hidden relative flex flex-col justify-end">
            <div className="absolute inset-0 opacity-5 bg-[radial-gradient(#1A8CFF_1px,transparent_1px)] [background-size:16px_16px]"></div>
            
            {/* Message 1: Bot */}
            <div className="flex items-start space-x-2 animate-fade-up" style={{ animationDelay: '0.2s' }}>
                <div className="w-6 h-6 rounded-full bg-mira-accent/20 flex items-center justify-center mt-1 flex-shrink-0">
                    <span className="text-[10px] text-mira-accent font-bold">AI</span>
                </div>
                <div className="bg-mira-surface border border-mira-border p-3 rounded-2xl rounded-tl-none max-w-[85%]">
                    <p className="text-xs text-gray-300">¡Hola! 👋 Bienvenido a Dental Elite. ¿Te gustaría agendar una limpieza o revisión?</p>
                </div>
            </div>

             {/* Message 2: User */}
             <div className="flex items-start space-x-2 justify-end animate-fade-up" style={{ animationDelay: '1s' }}>
                <div className="bg-mira-accent p-3 rounded-2xl rounded-tr-none max-w-[85%] shadow-[0_0_10px_rgba(26,140,255,0.3)]">
                    <p className="text-xs text-white">Hola, ¿tienen un espacio para mañana? Necesito una limpieza.</p>
                </div>
            </div>

            {/* Message 3: Bot */}
            <div className="flex items-start space-x-2 animate-fade-up" style={{ animationDelay: '2s' }}>
                <div className="w-6 h-6 rounded-full bg-mira-accent/20 flex items-center justify-center mt-1 flex-shrink-0">
                    <span className="text-[10px] text-mira-accent font-bold">AI</span>
                </div>
                <div className="bg-mira-surface border border-mira-border p-3 rounded-2xl rounded-tl-none max-w-[85%]">
                    <p className="text-xs text-gray-300">¡Claro! 😊 Tengo disponibles 10:00 AM y 4:30 PM. ¿Cuál horario prefieres?</p>
                </div>
            </div>

             {/* Message 4: User */}
             <div className="flex items-start space-x-2 justify-end animate-fade-up" style={{ animationDelay: '3s' }}>
                <div className="bg-mira-accent p-3 rounded-2xl rounded-tr-none max-w-[85%] shadow-[0_0_10px_rgba(26,140,255,0.3)]">
                    <p className="text-xs text-white">A las 10:00.</p>
                </div>
            </div>

            {/* Message 5: Bot */}
            <div className="flex items-start space-x-2 animate-fade-up" style={{ animationDelay: '4s' }}>
                <div className="w-6 h-6 rounded-full bg-mira-accent/20 flex items-center justify-center mt-1 flex-shrink-0">
                    <span className="text-[10px] text-mira-accent font-bold">AI</span>
                </div>
                <div className="bg-mira-surface border border-mira-border p-3 rounded-2xl rounded-tl-none max-w-[85%]">
                    <p className="text-xs text-gray-300">Perfecto. ✔️ Tu cita está confirmada para mañana a las 10:00 AM. Te enviaré un recordatorio un día antes.</p>
                </div>
            </div>
        </div>

        {/* Input Area */}
        <div className="p-3 bg-[#1A2333] border-t border-mira-border flex items-center space-x-2">
            <Paperclip className="w-5 h-5 text-gray-500 hover:text-mira-accent cursor-pointer transition-colors" />
            <div className="flex-1 bg-mira-bg rounded-full h-9 border border-mira-border flex items-center px-3 text-xs text-gray-400">
                Escribe un mensaje...
            </div>
            <div className="w-9 h-9 rounded-full bg-mira-accent flex items-center justify-center shadow-lg hover:bg-blue-400 cursor-pointer transition-colors">
                <Send className="w-4 h-4 text-white" />
            </div>
        </div>

      </div>
    </div>
  );
};

export default ChatMockup;